import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import Feed from "./Feed";

function App() {
  const auth = useAuth();

  // ---------------------------------------------------------
  // 1. Clean up OAuth redirect URL AFTER OIDC processes the code
  // ---------------------------------------------------------
  useEffect(() => {
    const url = new URL(window.location.href);

    if (auth.isAuthenticated && url.searchParams.has("code")) {
      console.log("Cleaning up OAuth redirect URL");
      window.history.replaceState({}, "", "/");
    }
  }, [auth.isAuthenticated]);

  // ---------------------------------------------------------
  // 2. User gesture listener (your existing code)
  // ---------------------------------------------------------
  useEffect(() => {
    const handler = () => {
      console.log("User gesture registered — SW can now focus windows");
      window.removeEventListener("click", handler);
    };
    window.addEventListener("click", handler);
  }, []);

  // ---------------------------------------------------------
  // 3. Auth flow
  // ---------------------------------------------------------
  const signOutRedirect = () => {
    auth.signoutRedirect({
      extraQueryParams: {
        client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
        logout_uri: process.env.REACT_APP_REDIRECT_SIGNOUT,
      },
    });
  };

  if (auth.isAuthenticated) {
    return (
      <Feed
        token={auth.user?.id_token}
        user={auth.user}
        onSignOut={signOutRedirect}
      />
    );
  }

  if (!auth.isAuthenticated && !auth.isLoading) {
    auth.signinRedirect();
    return null;
  }

  return <div>Loading…</div>;
}

export default App;